import axios from 'axios';
import { config } from "./config";
import CryptoJS from 'crypto-js';
import * as globalFunction from './GlobalFunction';

export const httpClient = axios.create({
  baseURL: config.baseUrl, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json'
  },
});

httpClient.interceptors.request.use(function (client) {
  // Do something before request is sent
  client.headers.Security = CryptoJS.AES.encrypt(globalFunction.getUTCDate(), CryptoJS.enc.Utf8.parse(config.aesKey), {
    iv: CryptoJS.enc.Utf8.parse(config.aesIV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString(); // Set your new security value here
  return client;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export const uploadClient = axios.create({
  baseURL: config.baseUrl, //YOUR_API_URL HERE
  // headers: {
  //   'Authorization': 'Bearer ' + localStorage.getItem('token')
  // },
});

uploadClient.interceptors.request.use(function (client) {
  // Do something before request is sent
  client.headers.Security = CryptoJS.AES.encrypt(globalFunction.getUTCDate(), CryptoJS.enc.Utf8.parse(config.aesKey), {
    iv: CryptoJS.enc.Utf8.parse(config.aesIV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString(); // Set your new security value here
  return client;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export const psmaClient = axios.create({
  baseURL: 'https://api.psma.com.au',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': config.psmaKey
  },
});

export const googleMapClient = axios.create({
  baseURL: 'https://maps.googleapis.com',
});
